const INITIAL_STATE = {
  data: {},
  errors: {},
      
}
const getAllAccountListing = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_ACCOUNT_LISTING_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_ACCOUNT_LISTING_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
      
export default getAllAccountListing;